<template>
  <div class="content-body" style="padding-top: 6rem">
    <div class="container-fluid">
      <!-- Button Add -->
      <router-link
        :to="{ name: 'Tambah Slider Testimoni Home' }"
        class="btn btn-primary mb-4"
        >Tambah</router-link
      >

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="form-group">
                <h4 class="card-title mb-3">
                  Cari Data {{ currentRouteName }}
                </h4>
                <!-- Search bar -->
                <div class="d-flex align-items-center">
                  <input
                    v-model="searchQuery"
                    @input="handleSearch"
                    class="form-control mr-2"
                    placeholder="Cari berdasarkan nama..."
                    style="width: 250px"
                  />
                  <button @click="handleSearch" class="btn btn-primary btn-sm">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Photo</th>
                      <th>Nama</th>
                      <th>Company</th>
                      <!-- <th>Kategori</th> -->
                      <th>Deskripsi</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-if="!filteredData || !filteredData.length"
                      class="text-center"
                    >
                      <td colspan="8">No Data</td>
                    </tr>
                    <tr v-for="(item, index) in paginatedData" :key="item.id">
                      <td>
                        {{ index + 1 + (currentPage - 1) * itemsPerPage }}
                      </td>
                      <td>
                        <img
                          :src="getImageUrl(item)"
                          :alt="item.nama || 'Foto'"
                          style="
                            width: 80px;
                            height: 80px;
                            aspect-ratio: 1 / 1;
                            border-radius: 8px;
                            object-fit: cover;
                          "
                        />
                      </td>
                      <td>
                        <strong>{{ item.nama }}</strong>
                      </td>
                      <td>{{ item.nama_perusahaan || item.company || "-" }}</td>
                      <!-- <td>
                        {{
                          item.kategori?.nama ||
                          item.kategori?.judul ||
                          item.kategori ||
                          "Slider Apa kata mereka"
                        }}
                      </td> -->
                      <td>
                        <div
                          v-html="truncateText(item.deskripsi || '', 20)"
                        ></div>
                      </td>
                      <td>
                        <span
                          :class="
                            isPublished(item)
                              ? 'badge badge-success'
                              : 'badge badge-danger'
                          "
                        >
                          {{ isPublished(item) ? "Publish" : "Unpublish" }}
                        </span>
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'Edit Slider Testimoni Home',
                            params: { id: item.id },
                          }"
                          class="btn btn-primary btn-rounded btn-sm mr-1 mb-1"
                        >
                          <i class="fa fa-pencil color-muted"></i>
                        </router-link>
                        <button
                          type="button"
                          @click="confirmDelete(item.id)"
                          class="btn btn-dark btn-rounded btn-sm mr-1 mb-1"
                        >
                          <i class="fa fa-trash color-muted"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Pagination -->
              <nav>
                <ul class="pagination justify-content-end mt-3">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="prevPage"
                      >Previous</a
                    >
                  </li>
                  <li
                    v-for="page in totalPages"
                    :key="page"
                    class="page-item"
                    :class="{ active: page === currentPage }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="goToPage(page)"
                    >
                      {{ page }}
                    </a>
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="nextPage"
                      >Next</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../axios";
import defaultURL from "@/config";

export default {
  name: "Slider Testimoni Home",
  setup() {
    const store = useStore();
    const route = useRoute();
    const currentRouteName = computed(() => route.name);
    const testimoniList = ref([]);
    const id_kategori = 11; // Kategori 11 = Slider Apa kata mereka (Home)

    const currentPage = ref(1);
    const itemsPerPage = 10;
    const searchQuery = ref("");

    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const token = computed(() => store.getters.token);
    const tokenExpiry = computed(() => store.getters.tokenExpiry);

    if (
      !token.value ||
      !tokenExpiry.value ||
      new Date() > new Date(tokenExpiry.value) ||
      !isAuthenticated.value
    ) {
      Swal.fire({
        title: "Error",
        text: `Session expired or invalid`,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        store.dispatch("setAuth", false);
        store.dispatch("setToken", { token: null, expiry: null });
        localStorage.clear();
        window.location.href = "/";
      });
      return;
    }

    const isPublished = (item) => {
      if (item.is_publish !== undefined && item.is_publish !== null) {
        return (
          item.is_publish === true ||
          item.is_publish === "true" ||
          item.is_publish === 1 ||
          item.is_publish === "1"
        );
      }
      if (item.publish !== undefined && item.publish !== null) {
        return (
          item.publish === true ||
          item.publish === "true" ||
          item.publish === 1 ||
          item.publish === "1"
        );
      }
      return false;
    };

    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/testi-kategori/${id_kategori}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token.value}`,
            },
          },
        );

        if (response.status === 200 && response.data) {
          testimoniList.value = response.data.data || response.data || [];
        }
      } catch (error) {
        console.error("Fetch error:", error);
        Swal.fire({
          title: "Error",
          text: `Error: ${error.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    const confirmDelete = (id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteData(id);
        }
      });
    };

    const deleteData = async (id) => {
      try {
        await axiosInstance.delete(`/testi/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        fetchData();
      } catch (error) {
        Swal.fire("Error", `Failed to delete data: ${error.message}`, "error");
      }
    };

    const getImageUrl = (item) => {
      if (item && (item.image || item.photo)) {
        const imgName = item.image || item.photo;
        if (imgName.startsWith("http")) return imgName;
        return `${defaultURL}/images/testi/${imgName}`;
      }
      return "https://via.placeholder.com/100?text=No+Photo";
    };

    const truncateText = (text, length) => {
      if (!text) return "";
      const stripped = text.replace(/<[^>]*>?/gm, "");
      return stripped.length > length
        ? stripped.slice(0, length) + "..."
        : stripped;
    };

    const filteredData = computed(() => {
      return testimoniList.value.filter(
        (item) =>
          (item.nama || "")
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()) ||
          (item.nama_perusahaan || item.company || "")
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()),
      );
    });

    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage;
      return filteredData.value.slice(start, start + itemsPerPage);
    });

    const totalPages = computed(() => {
      return Math.ceil(filteredData.value.length / itemsPerPage) || 1;
    });

    const handleSearch = () => {
      currentPage.value = 1;
    };

    const goToPage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    onMounted(() => {
      fetchData();
    });

    return {
      currentRouteName,
      testimoniList,
      fetchData,
      deleteData,
      confirmDelete,
      getImageUrl,
      searchQuery,
      handleSearch,
      filteredData,
      paginatedData,
      currentPage,
      totalPages,
      goToPage,
      itemsPerPage,
      nextPage,
      prevPage,
      truncateText,
      isPublished,
    };
  },
};
</script>

<style scoped>
.content-body {
  background: #f4f4f9;
}

table {
  width: 100%;
}

thead th {
  font-size: 14px;
}

th,
td {
  word-wrap: break-word;
  white-space: normal;
}

.table-responsive {
  overflow-x: auto;
}
</style>
